import styled from 'styled-components';

export const RecordsListTableWrapper = styled.div`
  margin-top: 60px;
`;
